import {Controller} from "stimulus"

export default class extends Controller {

    connect() {
        console.log("log from business-merge controller");
    }

    toggleControl(e) {
        console.log("control toggled")
        e.target.closest(".merge-action").querySelector(".business-select-area").classList.toggle("hidden")
    }


    selectSubsumed(e) {
        const selectedRecord = e.target.closest('a');
        const subsumed = selectedRecord.dataset.subsumedId || selectedRecord.id;
        const subsumedType = selectedRecord.dataset.subsumedType || "business";
        const subsumedname = selectedRecord.querySelector('.result-primary').innerText
        if (subsumed.length > 0) {
            if (confirm('Merge bz-' + subsumed + ': ' + subsumedname)) {
                console.log("subsumed selected")
                fetch(window.location.href + '/subsume?subsumed=' + encodeURIComponent(subsumed) + '&subsumed_type=' + encodeURIComponent(subsumedType))
                    .then(async response => {
                        const payload = await this.readJsonSafely(response)
                        if (!response.ok) {
                            throw new Error(this.errorMessageFromPayload(payload))
                        }

                        console.log("subsume successful")
                        window.location.reload();
                    })
                    .catch((error) => {
                        this.showFlashError(error.message)
                    });
            } else {
                e.target.closest('.business-select-area').classList.add("hidden");
                e.target.closest('.business-select-area').querySelector(".new-business-form").classList.add("hidden");

            }
        }
    }

    async readJsonSafely(response) {
        try {
            return await response.json();
        } catch {
            return {};
        }
    }

    errorMessageFromPayload(payload) {
        if (payload && payload.message) {
            return payload.message;
        }
        return "Business merge failed";
    }

    showFlashError(message) {
        const flashArea = document.getElementById("flash-area");
        if (!flashArea) {
            return;
        }
        const node = document.createElement("p");
        node.className = "alert";
        node.textContent = message;
        flashArea.innerHTML = "";
        flashArea.appendChild(node);
    }
}
